import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signIn, confirmSignIn } from "aws-amplify/auth";

const Login = () => {
  const [username, setUsername] = useState("user-123");
  // const [password, setPassword] = useState("password");
  const [password, setPassword] = useState("NewPassword123!");
  const [error, setError] = useState("");
  const navigate = useNavigate();

const handleLogin = async () => {
  setError("");
  try {
  const { nextStep } = await signIn({ username, password });

    if (nextStep?.signInStep === "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED") {
      await confirmSignIn({ challengeResponse: "NewPassword123!" });
    }

    navigate("/home");
  } catch (err) {
    if (err.name === "UserAlreadyAuthenticatedException") {
      console.warn("すでにログイン済み。再ログイン不要。");
      navigate("/home"); // そのまま次の画面へ
      return;
    }

    console.error("Login error:", err);
    setError("ログインに失敗しました。ユーザー名またはパスワードを確認してください。");
  }
};
  return (
    <div style={{ padding: "2rem" }}>
      <h2>ログイン</h2>
      <input value={username} onChange={(e) => setUsername(e.target.value)} />
      <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
      <button onClick={handleLogin}>ログイン</button>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default Login;